<script>
export default {
  functional: true,
  props: {
    labelFor: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: [String, Object],
      default: '',
    },
    message: {
      type: [String, Object, Array],
      default: '',
    },
  },
  render(createElement, context) {
    const componentClass = 'f-field'
    const data = {
      ...context.data,
      staticClass: [context.data.staticClass, componentClass].join(' ').trim(),
      props: {
        ...context.props,
      },
    }
    return createElement('b-field', data, context.children)
  },
}
</script>

<style scoped>
.f-field >>> .help {
  font-family: 'Exo 2', sans-serif;
  @apply tw-text-xs tw-leading-[14px] tw-font-normal tw-tracking-[0.08em] tw-mt-0;
}

.f-field >>> .help:not([class*='is-danger']) {
  @apply tw-text-[#6D666E];
}

.f-field >>> .label {
  font-family: 'Exo 2', sans-serif;
  @apply tw-text-xs tw-leading-[14px] tw-font-normal tw-tracking-[0.08em] tw-mb-0 tw-text-[#2F2B31];
}

.f-field >>> .input {
  font-family: 'Exo 2', sans-serif;
  @apply tw-rounded tw-shadow-none;
}
</style>
